// filepath: apps/web/src/features/admin/webhooks/WebhookEndpointsRoute.tsx
//
// FR-UI-ADM-6 AC-3 -- route shell for the webhook endpoint admin
// editor.
//
// URL: /admin/webhooks/endpoints
//
// The route enforces the staging-only gate at the SPA layer
// (defense-in-depth; the server rejects production writes with
// HTTP 403 ENV_PRODUCTION on POST/PATCH/DELETE).

import React from "react";
import { StagingOnlyError } from "@/features/admin/StagingOnlyError";
import { WebhookEndpointsPage } from "./WebhookEndpointsPage";

interface WebhookEndpointsRouteProps {
  /** Resolved environment kind from /api/tenant-config. */
  environmentKind: string;
}

export function WebhookEndpointsRoute({
  environmentKind,
}: WebhookEndpointsRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <WebhookEndpointsPage environmentKind={environmentKind} />;
}
